// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__E1f1p","modal-show":"Modal_modal-show__Nx29L","openModal":"Modal_openModal__RdPve","modal-bg-show":"Modal_modal-bg-show__NKWdW"};